import { Component, type ErrorInfo, type ReactNode } from "react";

import { AB_WIDGET_FETCH_LOG_PREFIX } from "./constants";

type Props = {
  children: ReactNode;
  onError: () => void;
};

export class TreatmentErrorBoundary extends Component<Props, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`${AB_WIDGET_FETCH_LOG_PREFIX} TreatmentErrorBoundary caught:`, error, errorInfo);
    this.props.onError();
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
